import { getApiErrorMessage } from './apiErrors'

export const rejectWithApiError = (rejectWithValue, error, fallback) =>
  rejectWithValue(getApiErrorMessage(error, fallback))
